<template>
  <v-main class="accent1">
    <!-- <layout-drawer /> -->

    <v-responsive class="mx-auto overflow-visible">
      <v-container fluid class="pa-0">
        <!-- <layout-breadcrumbs /> -->
        <!-- <v-divider class="mb-4 mt-2" insert></v-divider> -->

        <v-responsive class="overflow-visible" min-height="90vh">
          <router-view />
        </v-responsive>

        <!-- <documentation-contribution /> -->
        <core-create />
      </v-container>
    </v-responsive>
    <core-snack-bar></core-snack-bar>
  </v-main>
</template>

<script>
export default {
  name: 'LayoutView'
};
</script>
